module.exports = {["template-viewer-page"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="page hidden">\n		<div class="page-fixed-bg-container polyfill-sticky"></div>\n		<div class="fixed-position-container-top polyfill-sticky"></div>\n		<div class="fixed-position-container polyfill-sticky"></div>\n		<div class="content-scroll-wrapper '+
((__t=(isStickyVerticalViewer ? '' : 'has-vertical-scroll'))==null?'':__t)+
'">\n			<div class="content-bounds">\n				<div class="page-content-container" tabindex="-1"></div>\n			</div>\n		</div>\n	</div>\n';
}
return __p;
},}